import styled from 'styled-components';

import { PushContentDefinition } from 'modules/graphql/types';
import { Android16New, Apple16New } from 'ui/icons';
import { FormField, HelpText } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { spacing } from 'ui/theme';

import { getIsEditMode } from '../../common/utils';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';
import { InputTextWithBadge } from '../../common';
import { UrlInputFieldIcons } from '../../common/Controls/UrlInputFieldIcons';

const MediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

const InputWrapper = styled.div`
  padding-bottom: ${spacing.plusHalf};
`;

const StyledReadOnlyText = styled(SettingsReadOnlyText)`
  overflow-wrap: anywhere;
`;

const ReadOnlyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RichMedia = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  return (
    <FormField isHorizontalLayout labelText={SETTINGS_DISPLAY_CONTENT.mediaURL.labelText}>
      {isEditModeVisible ? (
        <MediaContainer>
          <InputWrapper>
            <InputText
              Prefix={
                <Badge variant={BADGE_VARIANTS.INFO}>
                  <Apple16New />
                </Badge>
              }
              Suffix={
                <UrlInputFieldIcons
                  mediumDataKey={'attachmentUrlIos'}
                  url={pushData.attachmentUrlIos}
                />
              }
              data-test="settings-template-push-ios"
              id="settings-template-push-ios"
              onChange={(iOS) => setCurrentMediumField('attachmentUrlIos', iOS)}
              placeholder={SETTINGS_DISPLAY_CONTENT.mediaURL.placeholder}
              value={pushData.attachmentUrlIos || ''}
              width="100%"
            />
            <HelpText>{SETTINGS_DISPLAY_CONTENT.mediaURL.helpTextiOS}</HelpText>
          </InputWrapper>

          <InputWrapper>
            <InputText
              Prefix={
                <Badge variant={BADGE_VARIANTS.INFO}>
                  <Android16New />
                </Badge>
              }
              Suffix={
                <UrlInputFieldIcons
                  mediumDataKey={'attachmentUrlAndroid'}
                  url={pushData.attachmentUrlAndroid}
                />
              }
              data-test="settings-template-push-android"
              id="settings-template-push-android"
              onChange={(android) => setCurrentMediumField('attachmentUrlAndroid', android)}
              placeholder={SETTINGS_DISPLAY_CONTENT.mediaURL.placeholder}
              value={pushData.attachmentUrlAndroid || ''}
              width="100%"
            />
            <HelpText>{SETTINGS_DISPLAY_CONTENT.mediaURL.helpTextAndroid}</HelpText>
          </InputWrapper>
        </MediaContainer>
      ) : (
        <>
          {pushData.attachmentUrlAndroid || pushData.attachmentUrlIos ? (
            <ReadOnlyContainer>
              {pushData.attachmentUrlIos && (
                <InputTextWithBadge
                  dataTest={'rich-media-ios-link'}
                  badgeContent={<Apple16New />}
                  link={pushData.attachmentUrlIos}
                />
              )}
              {pushData.attachmentUrlAndroid && (
                <InputTextWithBadge
                  dataTest={'rich-media-android-link'}
                  badgeContent={<Android16New />}
                  link={pushData.attachmentUrlAndroid}
                />
              )}
            </ReadOnlyContainer>
          ) : (
            <StyledReadOnlyText isUnset={true} data-test="rich-media-url-ro">
              {SETTINGS_DISPLAY_CONTENT.unsetText}
            </StyledReadOnlyText>
          )}
        </>
      )}
    </FormField>
  );
};
